import React from 'react';
import * as Styles from './About.styles';
import {
  Button, IconAdd,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import { useIsMobile } from '@/hooks/useIsMobile';
import ContentSection from '@/pages/Products/VpsOciDetailPage/commons/ContentSection';

const About = ({
  disableCreateKeyButton,
  handleOpenModalCreateKey,
}) => {
  const isMobile = useIsMobile();
  const { productDetails: productDetailsLocale } = useLocale();
  const { sshKeys: sshKeysLocale } = productDetailsLocale?.vpsOci;

  return (
    <ContentSection
      direction="row"
      align="center"
      justify="space-between"
      testId="ssh-keys-about"
    >
      <Styles.Wrapper>
        <Styles.Title data-testid="ssh-keys-about-title">{sshKeysLocale.management.title}</Styles.Title>
        <Styles.Description data-testid="ssh-keys-about-description">{sshKeysLocale.management.description}</Styles.Description>
      </Styles.Wrapper>
      <Button
        label={sshKeysLocale.management.createKeyButton}
        variant="primary"
        size="large"
        version="v2"
        width={isMobile ? 'full' : 'fit'}
        iconLeft={<IconAdd color={disableCreateKeyButton ? 'lowLight' : 'highPure'} />}
        notFillSVG
        onClick={handleOpenModalCreateKey}
        disabled={disableCreateKeyButton}
        testId="ssh-keys-about-create-key-button"
      />
    </ContentSection>
  );
};

export default About;
